import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@verantos-dev/core-annotation-tool';

import { setAnnotationAgentConcepts } from '../state/createProjectSlice';
import {
  selectAddedConcepts,
  selectAnnotationAgentConcepts,
  selectAnnotationAgentNextSequence,
} from '../state/selector';
import { mergeAgentConcepts } from '../utils/mergeAgentConcepts';

// TODO: cleanup with cp_annotation_createproject_agent ff

/**
 * Keeps the builder's concepts in step with the step 2 concept groups. Runs on mount and
 * whenever step 2 changes, and only reads step 2 state: it never dispatches a step 2 action.
 */
export const useSyncAgentConcepts = (enabled: boolean): void => {
  const dispatch = useAppDispatch();
  const addedConcepts = useAppSelector(selectAddedConcepts);
  const concepts = useAppSelector(selectAnnotationAgentConcepts);
  const nextSequence = useAppSelector(selectAnnotationAgentNextSequence);

  useEffect(() => {
    if (!enabled) return;
    const current = { concepts, nextSequence };
    const merged = mergeAgentConcepts(addedConcepts, current);
    if (merged !== current) {
      dispatch(setAnnotationAgentConcepts(merged));
    }
  }, [dispatch, enabled, addedConcepts, concepts, nextSequence]);
};
